import { ClientItem, SmartTimeExtendedProperty } from 'owa-mail-store';
import { action } from 'satcheljs';

export default action(
    'cacheSmartTimeExtendedPropertyAction',
    function cacheSmartTimeExtendedPropertyAction(
        item: ClientItem,
        validPropertyExists: boolean,
        smartTimesExtendedProp?: SmartTimeExtendedProperty
    ) {
        return {
            item: item,
            validPropertyExists: validPropertyExists,
            smartTimesExtendedProp: smartTimesExtendedProp,
        };
    }
);
